import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import { addOrUpdateMixingPoint } from "../../../actions/summerPointsActions";
import { useRef, useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { weatherCtx } from "../../../utils/hooks/mollierWeatherContext";
import { addOrUpdateMixingPointWinter } from "../../../actions/winterPointsActions";
import { useTranslation } from "react-i18next";

function Mixing(props) {
  const [newTemperature, setNewTemperature] = useState();
  const [powerUsed, setPowerUsed] = useState();
  const [coolingProccessVariable, setCoolingProcessVariable] = useState(20);
  const isFirstRender = useRef(true);
  const dispatch = useDispatch();
  const processPoint = useSelector((state) => state.processPoint);
  const winterPoints = useSelector((state) => state.winterPoints.winterPoints);
  const { summerWeather } = useContext(weatherCtx);
  const { chartConfig } = useContext(weatherCtx);
  const {t} = useTranslation()

  /* const indeks = processPoint.summerPoints.find((item) => {
    return item.process === 50;
  });*/
  // console.log(indeks);
  useEffect(() => {
    if (!isFirstRender.current) {
      isFirstRender.current = false;
      return; // Skip the first render
    }
    // if (indeks !== undefined)
    summerWeather
      ? dispatch(addOrUpdateMixingPoint(chartConfig.altitude, props.processID))
      : dispatch(
          addOrUpdateMixingPointWinter(chartConfig.altitude, props.processID)
        );
  }, []);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        spacing={1}
        alignItems="center"
        justifyContent="start"
        direction="row"
      >
        {/* <Grid item xs={5}>
            <TextField
              label="Outdoor temperature"
              id="outlined-start-adornment"
              // sx={{ m: 1, width: "25ch" }}
              name="altitude"
              //value={altitude}
              InputProps={{
                endAdornment: <InputAdornment position="end">m</InputAdornment>,
              }}
              //onChange={handleConfigChange}
              //onBlur={handleAxisChange}
            />
          </Grid>
          <Grid item xs={5}>
            <TextField
              label="Indoor temperature"
              id="outlined-start-adornment"
              name="airflow"
              //value={airflow}
              // sx={{ m: 1, width: "25ch" }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">m³/h</InputAdornment>
                ),
              }}
              //onChange={handleConfigChange}
            />
            </Grid>*/}
        <Grid item xs={5}>
          <TextField
            label={t("mollier.outsideAirFlow")}
            id="outlined-start-adornment"
            name="airflow"
            disabled
            value={
              summerWeather
                ? processPoint.summerPoints[0].airFlowHours
                : winterPoints[0].airFlowHours
            }
            //value={airflow}
            // sx={{ m: 1, width: "25ch" }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">m³/h</InputAdornment>
              ),
            }}
            //onChange={handleConfigChange}
          />
        </Grid>
        <Grid item xs={5}>
          <TextField
            label={t("mollier.insideAirFlow")}
            id="outlined-start-adornment"
            name="airflow"
            disabled
            value={
              summerWeather
                ? processPoint.summerPoints[1].airFlowHours
                : winterPoints[1].airFlowHours
            }
            //value={airflow}
            // sx={{ m: 1, width: "25ch" }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">m³/h</InputAdornment>
              ),
            }}
            //onChange={handleConfigChange}
          />
        </Grid>
      </Grid>{" "}
    </Box>
  );
}

export default Mixing;
